import Vue from "vue";
import i18n from "@/i18n";
import Router from "vue-router";
import store from "./store.js";

import Home from "@/views/Home";
import EditVolunteer from "@/views/forms/editVolunteer";
import Login from "@/views/Login";
import ChangePassword from "@/views/ChangePassword";
import NewVolunteer from "@/views/forms/NewVolunteer";

import Event from "@/views/Event.vue";
import Manuals from "@/views/Manuals.vue";
import Information from "@/views/Information.vue";
import Documents from "@/views/Documents.vue";
import SignDocument from "@/views/signDocument.vue";

let notifier = new Vue();
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login/",
      name: "login",
      component: Login,
      beforeEnter: loadLang,
      meta: {
        layout: "login"
      },
      props: {
        page: "login"
      }
    },
    {
      path: "/login/:lang",
      name: "login",
      component: Login,
      beforeEnter: loadLang,
      meta: {
        layout: "login"
      },
      props: {
        page: "login"
      }
    },
    {
      path: "/changepassword/:id/:limit/:lang",
      name: "changepassword",
      component: ChangePassword,
      meta: {
        layout: "login"
      },
      props: {
        page: "changepassword"
      }
    },
    {
      path: "/newvolunteer/:lang",
      name: "newvolunteer",
      component: NewVolunteer,
      beforeEnter: loadLang,
      meta: {
        layout: "login"
      },
      props: {
        page: "newvolunteer"
      }
    },
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: requireAuth,
      props: {
        page: "home"
      }
    },
    {
      path: "/edit",
      name: "edit",
      component: EditVolunteer,
      beforeEnter: requireAuth,
      props: {
        page: "edit"
      }
    },
    {
      path: "/:event_id",
      name: "event",
      component: Event,
      beforeEnter: requireAuth
    },
    {
      path: "/:event_id/manuals",
      name: "manuals",
      component: Manuals,
      beforeEnter: requireAuth
    },
    {
      path: "/:event_id/information",
      name: "necessary_information",
      component: Information,
      beforeEnter: requireAuth
    },
    {
      path: "/:event_id/documents",
      name: "necessary_documents",
      component: Documents,
      beforeEnter: requireAuth
    },
    {
      path: "/:event_id/documents/sign-individual-commitment",
      name: "sign_individual_commitment",
      component: SignDocument,
      beforeEnter: requireAuth
    },
    {
      path: "/viewmic/:entityid",
      name: "mic_view",
      beforeEnter: requireMICUser
    }
  ]
});

/*
    This will check to see if the user is authenticated or not.
*/
function requireAuth(to, from, next) {
  //console.log( to );
  // console.log( from );
  // console.log( next );
  // console.log( "requireAuth User state: " + store.getters['user/getUserLoadStatus']() );
  // console.log( store );
  /*
      Determines where we should send the user.
    */
  function proceed() {
    /*
          If the user has been loaded determine where we should
          send the user.
        */
    if (store.getters["user/getUserLoadStatus"]() == 2) {
      /*
              If the user is not empty, that means there's a user
              authenticated we allow them to continue. Otherwise, we
              send the user back to the home page.
            */
      var oSession = store.getters["user/getSession"];
      //console.log( oSession );
      localStorage.setItem("redirect", to.path);
      if (moment(oSession.exp * 1000).valueOf() > moment().valueOf()) {
        i18n
          .loadLanguageAsync(
            localStorage.getItem("language")
              ? localStorage.getItem("language")
              : "ca"
          )
          .then(function() {
            // store.commit( 'setPage', to.name );
            store.dispatch("setPage", to).then(function() {
              console.log("4");

              next();
            });
          });
      } else {
        store.dispatch("logout").then(function() {
          console.log("3");

          next({ name: "login" });
        });
      }
    }
  }

  /*
      Confirms the user has been loaded
    */
  if (store.getters["user/getUserLoadStatus"]() != 2) {
    /*
          If not, load the user
        */
    store.dispatch("loadUser").then(function() {
      //console.log( "WATCH: " + store.getters['user/getUserLoadStatus']() );
      if (store.getters["user/getUserLoadStatus"]() == 2) {
        // store.dispatch( 'loadTablesRelationship' ).then( function(){
        console.log("2");

        proceed();
        // });
      } else {
        store.dispatch("logout").then(function() {
          console.log("1");
          next({ name: "login" });
        });
      }
    });
  } else {
    /*
          User call completed, so we proceed
        */

    console.log("1");

    proceed();
  }
}

function loadLang(to, from, next) {
  to.params.lang;

  if (!["ca", "es"].includes(to.params.lang)) {
    to.params.lang = "ca";
  }

  i18n.loadLanguageAsync(to.params.lang).then(function() {
    next();
  });
}

function requireMICUser(to, from, next) {
  to.params.token = to.query.token;
  store.dispatch("loadMICUser", to.params).then(function() {
    next("/");
  });
}
